import {AppDocPermissions} from '@/types/permissions/document'

export const state = {}

export const getters = {
    getDocPermission: (state, getters, rootState, rootGetters) => (doc, userId = rootGetters.userUUID) => {
        const dt = rootGetters['documents/getDocumentTypeModel'](doc)
        if (dt && typeof dt.permissions === 'object') {
            return dt.permissions[userId]
        }
        return null
    },

    docPermission: (state, getters, rootState, rootGetters) => getters.getDocPermission(rootGetters['doc_viewer/doc']),

    canEditDoc: (state, getters, rootState, rootGetters) =>
        rootGetters.isStaff ||
        getters.hasFullAccessToDoc ||
        getters.hasOwnOnlyAccessToDoc ||
        getters.hasSubsidiaryOnlyAccessToDoc ||
        getters.hasLocationOnlyAccessToDoc,

    canViewDoc: (state, getters) =>
        getters.canEditDoc ||
        getters.hasReadOnlyAccessToDoc ||
        getters.hasReadOnlySubsidiaryAccessToDoc ||
        getters.hasReadOnlyLocationAccessToDoc,

    hasFullAccessToDoc: (state, getters) => getters.docPermission === AppDocPermissions.FULL,
    hasReadOnlyAccessToDoc: (state, getters) => getters.docPermission === AppDocPermissions.READ_ONLY,
    hasOwnOnlyAccessToDoc: (state, getters, rootState, rootGetters) =>
        getters.docPermission === AppDocPermissions.OWN_ONLY &&
        rootGetters['doc_viewer/users'].includes(rootGetters.userUUID),

    hasSubsidiaryOnlyAccessToDoc: (state, getters) =>
        getters.docPermission === AppDocPermissions.SUBSIDIARY_ONLY &&
        getters.hasAccessToEachDocSubsidiary,

    hasReadOnlySubsidiaryAccessToDoc: (state, getters) =>
        getters.docPermission === AppDocPermissions.READ_ONLY_SUBSIDIARY &&
        getters.hasAccessToEachDocSubsidiary,

    hasLocationOnlyAccessToDoc: (state, getters) =>
        getters.docPermission === AppDocPermissions.LOCATION_ONLY &&
        getters.hasAccessToEachDocLocation,

    hasReadOnlyLocationAccessToDoc: (state, getters) =>
        getters.docPermission === AppDocPermissions.READ_ONLY_LOCATION &&
        getters.hasAccessToEachDocLocation,

    hasAccessToEachDocLocation: (state, getters, rootState, rootGetters) =>
        rootGetters['doc_viewer/docUniqueLocations'].every(l => rootGetters.checkUserHasLocationAccess(l.uuid)),

    hasAccessToEachDocSubsidiary: (state, getters, rootState, rootGetters) =>
        rootGetters['doc_viewer/docUniqueSubsidiaries'].every(s => rootGetters.checkUserHasSubsidiaryAccess(s.uuid))
}

export const mutations = {}

export const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
